import { Component, OnInit } from "@angular/core";

@Component({
    selector: "ngx-token-release",
    template: `<ngx-one-column-layout>
        <router-outlet></router-outlet>
    </ngx-one-column-layout>`,
    styleUrls: ["./token-release.component.scss"],
})
export class TokenReleaseLayoutComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
